export default "__VITE_ASSET__yVw0gwon__"